import React from "react";
import { Trophy } from "lucide-react";
import { fmtPoints } from "../lib/api";

const tierStyles = {
    Silver: { bg: "from-[#9ca3af] to-[#475569]", text: "text-slate-200", glow: "rgba(148,163,184,0.3)" },
    Gold: { bg: "from-[#FFD700] to-[#B8860B]", text: "text-amber-100", glow: "rgba(255,215,0,0.35)" },
    Platinum: { bg: "from-[#E5E4E2] to-[#9CA3AF]", text: "text-white", glow: "rgba(229,231,235,0.35)" },
    Black: { bg: "from-[#1a1a1a] to-[#000]", text: "text-[#c9a959]", glow: "rgba(201,169,89,0.4)" },
};

export default function WalletCard({ customer, wallet }) {
    if (!wallet || !customer) {
        return <div className="h-52 rounded-3xl fx-glass animate-pulse" />;
    }
    const tier = customer.tier || "Silver";
    const style = tierStyles[tier] || tierStyles.Silver;
    const cashEquiv = (wallet.points_balance / 4).toFixed(0);

    // Tier progress
    const tierMap = { Silver: [0, 5000], Gold: [5000, 25000], Platinum: [25000, 100000], Black: [100000, 100000] };
    const [cur, next] = tierMap[tier];
    const progress = next > cur ? Math.min(100, ((wallet.lifetime_earned - cur) / (next - cur)) * 100) : 100;

    return (
        <div
            data-testid="wallet-card"
            className="relative overflow-hidden rounded-3xl p-6 border border-white/15 fx-grad-wallet"
            style={{ boxShadow: `0 30px 80px ${style.glow}` }}
        >
            <div className="flex items-center justify-between relative z-10">
                <div>
                    <p className="text-[10px] uppercase tracking-[0.25em] text-[#6b7280]">Fundle Wallet</p>
                    <p className="font-display font-semibold text-base mt-0.5">{customer.name || customer.mobile}</p>
                </div>
                <span
                    data-testid="wallet-tier"
                    className={`px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider bg-gradient-to-r ${style.bg} text-black inline-flex items-center gap-1`}
                >
                    <Trophy size={12} /> {tier}
                </span>
            </div>

            <div className="mt-9 relative z-10">
                <p className="text-xs uppercase tracking-widest text-[#6b7280]">Available Points</p>
                <p className="font-display text-5xl md:text-6xl font-extrabold mt-1" data-testid="wallet-balance">
                    {fmtPoints(wallet.points_balance).replace(" pts", "")}
                    <span className="text-[#c9a959] text-3xl md:text-4xl ml-2">pts</span>
                </p>
                <p className="text-[#4b5563] mt-1 text-sm">≈ ₹{cashEquiv} redeem value</p>
            </div>

            <div className="mt-6 relative z-10">
                <div className="flex items-center justify-between text-xs text-[#6b7280] mb-1.5">
                    <span>{tier} Tier Progress</span>
                    <span>{wallet.lifetime_earned.toLocaleString("en-IN")} / {next.toLocaleString("en-IN")}</span>
                </div>
                <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                    <div
                        className="h-full bg-[#c9a959]"
                        style={{ width: `${progress}%`, boxShadow: "0 0 12px rgba(201,169,89,0.6)" }}
                    />
                </div>
            </div>

            <div className="mt-6 flex items-center justify-between text-[11px] text-[#6b7280] relative z-10">
                <span>ID • {customer.loyalty_id}</span>
                <span>+91 {customer.mobile?.slice(-10)}</span>
            </div>

            {/* decorative chip */}
            <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#c9a959]/10 blur-3xl" />
            <div className="absolute -bottom-10 -left-10 w-40 h-40 rounded-full bg-[#ff4d4d]/10 blur-3xl" />
        </div>
    );
}
